import React, { useCallback } from 'react';
import { usePublish } from '@atlaskit/rovo-triggers';
import { ExplainWorkflowButton } from './explain-workflow-button/index.tsx';
import type { Props } from './types.tsx';

const ExplainWorkflow = ({ issueKey, onCloseModal }: Props) => {
	const publish = usePublish('ai-mate');

	const onClickHandler = useCallback(() => {
		publish({
			type: 'chat-new',
			product: 'jira',
			source: 'jira-work-item-status-dropdown',
			data: {
				dialogues: [],
				prompt: `How do I move ${issueKey} to the next status?`,
			},
		});
		onCloseModal?.();
	}, [issueKey, onCloseModal, publish]);

	return <ExplainWorkflowButton onClick={onClickHandler} />;
};

export default ExplainWorkflow;
